import { render, staticRenderFns } from "./share-drawer.vue?vue&type=template&id=4212ae56&"
import script from "./share-drawer.vue?vue&type=script&lang=js&"
export * from "./share-drawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports